<template>
    <page-loading v-if="loading"></page-loading>
    <vx-page-layout v-else :layout="props.phoneNumberPoolId ? 'sidebar' : 'create'">
        <template v-slot:title>
            <span v-if="!props.phoneNumberPoolId" class="inline-flex items-center gap-3">
                <font-awesome-icon widthAuto :icon="faPhoneOffice" class="text-base"></font-awesome-icon>
                <span>New Phone Pool</span>
            </span>
            <slot v-else name="header">{{ phoneNumberPool.friendly_name }}</slot>
        </template>

        <template v-if="!props.phoneNumberPoolId" v-slot:description
            >Create a new phone pool backed by a messaging service.</template
        >

        <template v-if="props.phoneNumberPoolId" v-slot:subtitle>
            <a
                :href="`/settings/teams/${teamId}#/phone-number-pools`"
                class="no-underline! text-sky-600! text-base font-normal"
            >
                <font-awesome-icon widthAuto class="mr-1" :icon="faArrowLeft"></font-awesome-icon>
                All Phone Pools
            </a>
        </template>

        <template v-if="props.phoneNumberPoolId" v-slot:sidebar>
            <page-sidebar
                :links="[
                    {
                        href: `/settings/teams/${teamId}/phone-number-pools/${props.phoneNumberPoolId}`,
                        label: 'Details',
                    },
                    {
                        href: `/settings/teams/${teamId}/phone-number-pools/${props.phoneNumberPoolId}/phone-numbers`,
                        label: 'Phone Numbers',
                    },
                ]"
            ></page-sidebar>
        </template>
        <slot></slot>
    </vx-page-layout>
</template>

<script setup>
import { VxPageLayout } from '@voxie/frontend-components';
import PageLoading from '~/components/general/PageLoading.vue';
import { faArrowLeft, faPhoneOffice } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted, provide } from 'vue';
import { PAGE_HEADING_LEVEL } from '~/provides/pageHeadingLevel';
import { usePhoneNumberPoolDetails } from '~/components/settings/teams/phone-number-pools/usePhoneNumberPoolDetails';
import PageSidebar from '~/components/general/PageSidebar.vue';

const props = defineProps({
    phoneNumberPoolId: {
        type: Number,
        required: false,
    },
});

const teamId = Spark.state.currentTeam.id;
provide(PAGE_HEADING_LEVEL, 'h2');

const { phoneNumberPool, loading, mount } = usePhoneNumberPoolDetails();

onMounted(() => {
    mount(props.phoneNumberPoolId);
});
</script>
